import {
    XYGL
} from '../constants/funcUrl'

const xyglMutation = {
    [XYGL.MYSTUDY](state, data) {
        state.studys = data;
    },
    [XYGL.MYSTUDYDETAILS](state, data) {
        state.studyDetails = data;
    },
    [XYGL.MYSTUDYALBUMDETAILS](state, data) {
        state.studyLessonAlbumDetails = data;
    },
    [XYGL.MYSTUDYLESSONDETAILS](state, data) {
        state.studyLessonDetails = data;
    },
    [XYGL.POSTTESTQUESTION](state, data) {
        let index = 0;
        _.forEach(data, item => {
            if (item.SubQuestions !== null) {
                _.forEach(item.SubQuestions, subItem => {
                    index++;
                    subItem.index = index;
                    setNo(subItem.Answers);
                })
            } else {
                index++;
                item.index = index;
                setNo(item.Answers);
            }
        });

        state.posttestQuestions = data;
    },
    [XYGL.COURSEEXAMQUESTION](state, data) {
        let index = 0;
        _.forEach(data, item => {
            if (item.SubQuestions !== null) {
                _.forEach(item.SubQuestions, subItem => {
                    index++;
                    subItem.index = index;
                    setNo(subItem.Answers);
                })
            } else {
                index++;
                item.index = index;
                setNo(item.Answers);
            }
        });

        state.courseExamQuestions = data;
    },
    [XYGL.STUDYHGKSQUESTION](state, data) {
        state.hgksQuestions = data;
    },
    [XYGL.CERTLEARNCERT](state, data) {
        data.LearnCertDate = data.LearnCertDate.substring(0, data.LearnCertDate.length - 9)
        state.certLearncert = data;
    },
    [XYGL.EMPLOYEEPERSONALPROFILE](state, data) {
        state.personaLprofile = data;
    }
}

function setNo(list) {
    _.forEach(list, (answer, i) => {
        let no = '';
        switch (i) {
            case 0:
                no = 'A';
                break;
            case 1:
                no = 'B';
                break;
            case 2:
                no = 'C';
                break;
            case 3:
                no = 'D';
                break;
            case 4:
                no = 'E';
                break;
            case 5:
                no = 'F';
                break;
            default:
                no = '';
                break;
        }
        answer.No = no;
    });
}
export default xyglMutation;



// WEBPACK FOOTER //
// ./src/store/jzjy/mutations/xyglMutation.js